import { useState } from 'react'
import {
  PatientHomepageAllBookingsSection,
  PatientHomepageBookTherapySection,
  PatientHomepageExploreWellnessSection,
  PatientHomepageInvestigationsSection,
  PatientHomepageMyClinicsSection,
  PatientHomepagePrescriptionsSection,
  PatientHomepageTodaysBookingSection,
  PatientHomepageWelcomeSection,
} from './components'

export default function TilesPagePatient() {

  const [chosenPatientId, setChosenPatientId] = useState(sessionStorage.getItem('chosenPatientId') || null)

  return (
    <div style={{ paddingTop: '64px' }}>
      <div>
        <PatientHomepageWelcomeSection chosenPatientId={chosenPatientId} setChosenPatientId={setChosenPatientId} />
        <PatientHomepageTodaysBookingSection chosenPatientId={chosenPatientId} setChosenPatientId={setChosenPatientId} />
        {/* <PatientHomepagePrescriptionsSection chosenPatientId={chosenPatientId} setChosenPatientId={setChosenPatientId} /> */}
        {/* <PatientHomepageMyClinicsSection chosenPatientId={chosenPatientId} setChosenPatientId={setChosenPatientId} /> */}
        {/* <PatientHomepageBookTherapySection chosenPatientId={chosenPatientId} setChosenPatientId={setChosenPatientId} /> */}
        {/* <PatientHomepageInvestigationsSection chosenPatientId={chosenPatientId} setChosenPatientId={setChosenPatientId} /> */}
        {/* <PatientHomepageAllBookingsSection chosenPatientId={chosenPatientId} setChosenPatientId={setChosenPatientId} /> */}
        <PatientHomepageExploreWellnessSection chosenPatientId={chosenPatientId} setChosenPatientId={setChosenPatientId} />
      </div>
    </div>
  )
}
